import { useEffect } from 'react';
import StorageUtils from '@spothero/utils/storage';
import { StorageKeys } from 'common/constants/storageKeys';
import debounce from 'lodash/debounce';
export const useRestoreScrollPosition = (verticalScrollRef, horizontalScrollRef) => {
    useEffect(() => {
        const scrollPosition = StorageUtils.get(StorageKeys.SEARCH_SCROLL_POSITION.STORAGE_KEY, StorageKeys.SEARCH_SCROLL_POSITION.STORAGE_TYPE);
        if (scrollPosition) {
            // Restore vertical scroll
            if (verticalScrollRef.current && scrollPosition.top) {
                verticalScrollRef.current.scrollTop = scrollPosition.top;
            }
            // Restore horizontal scroll
            if (horizontalScrollRef?.current && scrollPosition.left) {
                horizontalScrollRef.current.scrollLeft = scrollPosition.left;
            }
            StorageUtils.remove(StorageKeys.SEARCH_SCROLL_POSITION.STORAGE_KEY, StorageKeys.SEARCH_SCROLL_POSITION.STORAGE_TYPE);
        }
    }, [verticalScrollRef, horizontalScrollRef]);
};
export const useSaveScrollPosition = (verticalScrollRef, horizontalScrollRef) => {
    useEffect(() => {
        const handleScroll = debounce(() => {
            const scrollPosition = {
                top: verticalScrollRef.current?.scrollTop || 0,
                left: horizontalScrollRef?.current?.scrollLeft || 0,
            };
            StorageUtils.set(StorageKeys.SEARCH_SCROLL_POSITION.STORAGE_KEY, scrollPosition, StorageKeys.SEARCH_SCROLL_POSITION.STORAGE_TYPE);
        }, 150);
        const verticalContainer = verticalScrollRef.current;
        const horizontalContainer = horizontalScrollRef?.current;
        // Add event listeners to both containers
        verticalContainer?.addEventListener('scroll', handleScroll);
        horizontalContainer?.addEventListener('scroll', handleScroll);
        return () => {
            verticalContainer?.removeEventListener('scroll', handleScroll);
            horizontalContainer?.removeEventListener('scroll', handleScroll);
            handleScroll.cancel();
        };
    }, [verticalScrollRef, horizontalScrollRef]);
};
